import { useTranslation } from "react-i18next";
import type { WidgetOptions } from "@/shared/types/widgetOptions";
import { TOOLTIP_BUTTON_CLASS } from "../../constants/tooltipButtonClass";
import { TOOLTIP_CONTENT_KEYS } from "../../constants/tooltipContent";
import type { MenuOptionResult } from "../../types";
import { MenuButton } from "../MenuButton/MenuButton";

export function MenuButtonRenderer({
    content,
    handleClick,
    isActive,
    isDisabled,
    tippyContent,
    name,
}: MenuOptionResult & {
    name: WidgetOptions;
}) {
    const { t } = useTranslation();
    const tooltipKey = TOOLTIP_CONTENT_KEYS[name];
    const tippyText = tippyContent || (tooltipKey ? t(tooltipKey) : "");
    const commonProps = {
        "data-tooltip": tippyText ?? "",
        className: TOOLTIP_BUTTON_CLASS,
    };

    const Button =
        typeof content === "string" ? (
            <MenuButton
                onClick={handleClick}
                isActive={isActive}
                // biome-ignore lint/security/noDangerouslySetInnerHtml: <Нужно для вставки инлайновых svg шейпов>
                dangerouslySetInnerHTML={{ __html: content }}
                {...commonProps}
            />
        ) : (
            <MenuButton
                onClick={handleClick}
                isActive={isActive}
                disabled={isDisabled}
                {...commonProps}
            >
                {content}
            </MenuButton>
        );

    return Button;
}
